module.exports = __webpack_public_path__ + "static/media/Stellar King Drawer Bed Base - 180x210 cm_Cream.09fe62e1.png";